import { useRef, useState, useCallback, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import {
    RefrigeratorSvg,
    WiFiRouterSvg,
    TVSvg,
    MicrowaveSvg,
    BlenderSvg,
    WasherSvg,
    PortableFridgeSvg,
    HairDryerSvg,
    CoffeeMakerSvg,
    ElectricGrillSvg,
    ProjectorSvg,
    PhoneSvg,
    CircularSawSvg,
    ElectricHammerSvg,
    CuttingMachineSvg,
    WeldingMachineSvg,
    CameraSvg,
    LaptopSvg,
    DroneSvg,
    SpeakerSvg,
} from '@/components/UI/svg/delta2max';

export default function F() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('delta2max.detail');

    const [tabActive, setTabActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrLeftRef = useRef<Array<number>>([0]);
    const arrWidthRef = useRef<Array<number>>([]);
    const zoomRef = useRef<HTMLDivElement>(null);

    const itemList1 = [
        {
            name: t('sec6_Refrigerator'),
            times: 'sec6_Refrigerator_times',
            icon: <RefrigeratorSvg />,
        },
        {
            name: t('sec6_WiFiRouter'),
            times: 'sec6_WiFiRouter_times',
            icon: <WiFiRouterSvg />,
        },
        {
            name: t('sec6_Tv'),
            times: 'sec6_Tv_times',
            icon: <TVSvg />,
        },
        {
            name: t('sec6_Microwave'),
            times: 'sec6_Microwave_times',
            icon: <MicrowaveSvg />,
        },
        {
            name: t('sec6_Blender'),
            times: 'sec6_Blender_times',
            icon: <BlenderSvg />,
        },
        {
            name: t('sec6_CPAP'),
            times: 'sec6_CPAP_times',
            icon: <WasherSvg />,
        },
    ];
    const itemList2 = [
        {
            name: t('sec6_PortableFridge'),
            times: 'sec6_PortableFridge_times',
            icon: <PortableFridgeSvg />,
        },
        {
            name: t('sec6_HairDryer'),
            times: 'sec6_HairDryer_times',
            icon: <HairDryerSvg />,
        },
        {
            name: t('sec6_CoffeeMaker'),
            times: 'sec6_CoffeeMaker_times',
            icon: <CoffeeMakerSvg />,
        },
        {
            name: t('sec6_ElectricGrill'),
            times: 'sec6_ElectricGrill_times',
            icon: <ElectricGrillSvg />,
        },
        {
            name: t('sec6_Projector'),
            times: 'sec6_Projector_times',
            icon: <ProjectorSvg />,
        },
        {
            name: t('sec6_Phone'),
            times: 'sec6_Phone_times',
            icon: <PhoneSvg />,
        },
    ];
    const itemList3 = [
        {
            name: t('sec6_CircularSaw'),
            times: 'sec6_CircularSaw_times',
            icon: <CircularSawSvg />,
        },
        {
            name: t('sec6_ElectricHammer'),
            times: 'sec6_ElectricHammer_times',
            icon: <ElectricHammerSvg />,
        },
        {
            name: t('sec6_CuttingMachine'),
            times: 'sec6_CuttingMachine_times',
            icon: <CuttingMachineSvg />,
        },
        {
            name: t('sec6_WeldingMachine'),
            times: 'sec6_WeldingMachine_times',
            icon: <WeldingMachineSvg />,
        },
    ];
    const itemList4 = [
        {
            name: t('sec6_Camera'),
            times: 'sec6_Camera_times',
            icon: <CameraSvg />,
        },
        {
            name: t('sec6_Laptop'),
            times: 'sec6_Laptop_times',
            icon: <LaptopSvg />,
        },
        {
            name: t('sec6_Drone'),
            times: 'sec6_Drone_times',
            icon: <DroneSvg />,
        },
        {
            name: t('sec6_Speaker'),
            times: 'sec6_Speaker_times',
            icon: <SpeakerSvg />,
        },
    ];

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[]) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];
            arrHRef.push(item.clientWidth);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientWidth + 40);
            } else {
                arrTRef.push(item.clientWidth + 40);
            }
        }
    }, []);

    const changeTab = useCallback((index: number) => {
        setTabActive(index);
        const ind = Number(index);
        (domChildRef.current as HTMLDivElement).style.cssText = `width: ${arrWidthRef.current[ind]}px; left: ${arrLeftRef.current[ind]}px`;
    }, []);

    const swiperChange = (e: any) => {
        onSwiperSlideTo(e.activeIndex);
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== tabActive) {
            swiper?.slideTo(index);
        }
        changeTab(index);
    };

    useEffect(() => {
        // 初始化tab1切换数据
        initMove(domRef.current, arrWidthRef.current, arrLeftRef.current);
        changeTab(0);
    }, []);

    return (
        <div
            ref={zoomRef}
            className={`d2x-detail-F ${css.d2xDetailF} GtmModuleData-section`}
            id="d2x-detail-F"
            data-section-id={'d2x-detail-F'}
            data-section-title={t('sec6_title')}
        >
            <p className="slogan">{t('sec6_slogan')}</p>
            <p className="title">{t('sec6_title')}</p>
            <div ref={domRef} className={`tab active-0${tabActive}`}>
                <button
                    onClick={() => {
                        onSwiperSlideTo(0);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec6_tab1'),
                            list_name: t('sec6_title'),
                        });
                    }}
                >
                    {t('sec6_tab1')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(1);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec6_tab2'),
                            list_name: t('sec6_title'),
                        });
                    }}
                >
                    {t('sec6_tab2')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(2);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec6_tab3'),
                            list_name: t('sec6_title'),
                        });
                    }}
                >
                    {t('sec6_tab3')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(3);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec6_tab4'),
                            list_name: t('sec6_title'),
                        });
                    }}
                >
                    {t('sec6_tab4')}
                </button>
                <span ref={domChildRef}></span>
            </div>
            <Swiper
                className="content"
                pagination={false}
                slidesPerView={'auto'}
                initialSlide={0}
                effect="fade"
                spaceBetween={20}
                onSlideChange={swiperChange}
                onSwiper={(swiper: any) => setSwiper(swiper)}
            >
                <SwiperSlide className="info-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/detail/pc/6-1.webp')}
                        src={require('@publicLocal/delta2max/detail/pc/6-1.jpg')}
                        alt={t('sec6_slogan')}
                        aria-label={t('sec6_slogan')}
                    />
                    <div className="points">
                        {itemList1.map((item: any, index: number) => (
                            <div key={index} className="point">
                                <div className="itemImg">{item.icon}</div>
                                <div className="itemName">{item.name}</div>
                                <div className="itemTimes">
                                    {t.rich(item.times, {
                                        line: (text: any) => <span>{text}</span>,
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>
                <SwiperSlide className="info-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/detail/pc/6-2.webp')}
                        src={require('@publicLocal/delta2max/detail/pc/6-2.jpg')}
                        alt={t('sec6_slogan')}
                        aria-label={t('sec6_slogan')}
                    />
                    <div className="points">
                        {itemList2.map((item: any, index: number) => (
                            <div key={index} className="point">
                                <div className="itemImg">{item.icon}</div>
                                <div className="itemName">{item.name}</div>
                                <div className="itemTimes">
                                    {t.rich(item.times, {
                                        line: (text: any) => <span>{text}</span>,
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>
                <SwiperSlide className="info-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/detail/pc/6-3.webp')}
                        src={require('@publicLocal/delta2max/detail/pc/6-3.jpg')}
                        alt={t('sec6_slogan')}
                        aria-label={t('sec6_slogan')}
                    />
                    <div className="points">
                        {itemList3.map((item: any, index: number) => (
                            <div key={index} className="point">
                                <div className="itemImg">{item.icon}</div>
                                <div className="itemName">{item.name}</div>
                                <div className="itemTimes">
                                    {t.rich(item.times, {
                                        line: (text: any) => <span>{text}</span>,
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>
                <SwiperSlide className="info-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/detail/pc/6-4.webp')}
                        src={require('@publicLocal/delta2max/detail/pc/6-4.jpg')}
                        alt={t('sec6_slogan')}
                        aria-label={t('sec6_slogan')}
                    />
                    <div className="points">
                        {itemList4.map((item: any, index: number) => (
                            <div key={index} className="point">
                                <div className="itemImg">{item.icon}</div>
                                <div className="itemName">{item.name}</div>
                                <div className="itemTimes">
                                    {t.rich(item.times, {
                                        line: (text: any) => <span>{text}</span>,
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>
            </Swiper>
            <p className="desc">{t('sec6_desc')}</p>
            <p className="tip">{t('sec6_tip')}</p>
        </div>
    );
}
